export const CRMNameMap: Record<number, string> = {
  0: 'none',
  4: 'salesforce',
  5: 'zendesk',
  6: 'nutshell',
  8: 'amo',
  13: 'zoho',
  14: 'insightly',
  15: 'copper',
  16: 'hubspot',
  17: 'pipedrive',
  18: 'capsule',
  20: 'pipelineDeals',
  23: 'custom',
  24: 'activeCampaign',
  25: 'freshSales',
  26: 'outreach',
  30: 'ghl',
};

export const CRMDisplayNameMap: {
  [key: string]: string;
} = {
  activeCampaign: 'Active Campaign',
  amo: 'Amo',
  capsule: 'Capsule',
  copper: 'Copper',
  custom: 'Custom CRM',
  freshSales: 'Fresh Sales',
  ghl: 'GHL',
  hubspot: 'Hubspot',
  insightly: 'Insightly',
  none: 'None',
  nutshell: 'Nutshell',
  outreach: 'Outreach',
  pipelineDeals: 'Pipeline Deals',
  pipedrive: 'Pipedrive',
  salesforce: 'Salesforce',
  zendesk: 'Zendesk',
  zoho: 'Zoho',
};

export const CRMIDMap: Record<string, number> = {
  activeCampaign: 24,
  amo: 8,
  capsule: 18,
  copper: 15,
  custom: 23,
  freshSales: 25,
  ghl: 30,
  hubspot: 16,
  insightly: 14,
  none: 0,
  nutshell: 6,
  outreach: 26,
  pipelineDeals: 20,
  pipedrive: 17,
  salesforce: 4,
  zendesk: 5,
  zoho: 13,
};
